import { Event } from '@jd/jmtd-tools/es/event';
var event = Event();
export function addEventTrackingListener(callback) {
  event.register(callback);
}
export function trackEvent(_ref) {
  var _ref$componentName = _ref.componentName,
      componentName = _ref$componentName === void 0 ? '' : _ref$componentName,
      _ref$locationName = _ref.locationName,
      locationName = _ref$locationName === void 0 ? '' : _ref$locationName,
      _ref$eventName = _ref.eventName,
      eventName = _ref$eventName === void 0 ? '' : _ref$eventName,
      _ref$eventValue = _ref.eventValue,
      eventValue = _ref$eventValue === void 0 ? '' : _ref$eventValue;
  event.trigger({
    componentName: componentName,
    locationName: locationName,
    eventName: eventName,
    eventValue: eventValue
  });
}